module.exports = __webpack_public_path__ + "static/media/pago7.a541b30e.svg";